import { useEffect, useState } from 'react';
import FieldChooser from './FieldChooser';
import OperatorChooser from './OperatorChooser';
import ValueTypeChooser from './ValueTypeChooser';
import { FormControl, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FieldNames from '../../../defaults/FieldNames.json';
import {
  getValidOperators,
  getShortStringOperators,
  getDefaultFilterValue,
  getStringExclusionOperator,
  getStringEquivalenceOperator,
  getEmptyOperator,
} from '../utils/genericUtils';
import { getAgencyOptions, getDepartmentOptions, getFundingUnitTypeOptions, getNameOptions, getRegionOptions, getStates, getSubUnitOptions, getTribeOptions, getUnitOptions, getCountyOptions, getFundingSourceOptions } from '../../filter/customFilters/FilterHelper';
import { useSelector } from 'react-redux';
import ColorConstants from '../../../defaults/ColorConstants';
import FieldValueChooser from './FieldValueChooser';


const formControlContainerStyles = {
  marginBottom: '5px',
  justifyContent: 'flex-end',
  width: '100%',
  paddingRight: '5px'
}

const formControlStyles = {
  marginBottom: '5px',
  justifyContent: 'flex-end',
  width: 'auto',
  paddingRight: '5px'
};

const deleteStyles = {
  marginBottom: '5px',
  justifyContent: 'flex-end',
  width: 17,
  paddingRight: '5px'
}

export default function Expression({key, id, disableUnique, overrideStringOperators, expressionDef, 
  fields, updateExpression, removeExpression, statusOptions, isDropdownLoading, setIsDropdownLoading, datasetSelection}){

    const fundingDepartmentOptions = useSelector((state) => state.globalContext.fundingDepartmentOptions);
    const fundingAgencyOptions = useSelector((state) => state.globalContext.fundingAgencyOptions);
    const fundingRegionOptions = useSelector((state) => state.globalContext.fundingRegionOptions);
    const fundingUnitOptions = useSelector((state) => state.globalContext.fundingUnitOptions);
    const fundingSubUnitOptions = useSelector((state) => state.globalContext.fundingSubUnitOptions);
    const fundingTribeOptions = useSelector((state) => state.globalContext.fundingTribeOptions);
    const fundingUnitTypeOptions = useSelector((state) => state.globalContext.fundingUnitTypeOptions);
    const wbsIDValues = useSelector((state) => state.globalContext.wbsIDValues);
    const congressDistValues = useSelector((state) => state.globalContext.congressDistValues);
    const countyOptions = useSelector((state) => state.globalContext.countyOptions);
    const nameValueOptions = useSelector((state) => state.globalContext.nameValueOptions);
    const actionCategoryAssociations = useSelector((state) => state.globalContext.actionCategoryAssociations);

    const config = useSelector((state) => state.configuration.config);
    const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
    const [fundingSourceOptions, setFundingSourceOptions] = useState([])

  useEffect(() => {
    if (fields?.length === 1)
    {
      const fieldInternal = fields[Object.keys(fields)[0]];
      updateOptionsFromField(fieldInternal);
    } 
  }, [])

  const updateExpressionInternal = updates => {
    updateExpression({ id: id, field: updates.fieldInternal, value: updates.valueInternal, operator: updates.operatorInternal, valueType: updates.valueType });
  };

  const removeExpressionInternal = () => {
    removeExpression(id);
  };

  const handleFieldChanged = (fieldInternal) => {
    updateOptionsFromField(fieldInternal);
  };

  const handleOperatorChanged = operatorInternal => {
    updateExpression({ id: id, field: expressionDef?.field, value: expressionDef?.value?.name !== undefined ? expressionDef.value.name : expressionDef.value, operator: operatorInternal, valueType: expressionDef.valueType });
  };

  const handleValueChanged = valueInternal => {
    updateExpression({ id: id, field: expressionDef?.field, value: valueInternal, operator: expressionDef.operator, valueType: expressionDef.valueType });
  };

  const handleValueTypeChanged = valueType => {
    updateExpression({ id: id, field: expressionDef?.field, value: expressionDef?.value?.name !== undefined ? expressionDef.value.name : expressionDef.value, operator: expressionDef.operator, valueType: valueType });
  };

  const getCustomCodedValues = async(name) => {
    let customCodedValues = [];
    if(name === "CongressionalDistrictNumber")
    {
      customCodedValues = congressDistValues.sort((a, b) => (a > b) ? 1 : -1);
    } else if(name === "HideNational") {
      customCodedValues = ["National"];
    } else if(name === "HideContributedOnly") {
      customCodedValues = [""];
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingDepartment){
      if(rootServiceUrl && config){
        if(!fundingDepartmentOptions || (fundingDepartmentOptions?.length === 0)){
          setIsDropdownLoading(true);
          customCodedValues = await getDepartmentOptions(setIsDropdownLoading)
        } else {
          if(fundingDepartmentOptions?.length > 0){
            customCodedValues = fundingDepartmentOptions;
          }
        }
      } 
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingSource){
      if(!fundingSourceOptions || (fundingSourceOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getFundingSourceOptions(setFundingSourceOptions, setIsDropdownLoading)
      } else {
        if(fundingSourceOptions?.length > 0){
          customCodedValues = fundingSourceOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingAgency){
      if(!fundingAgencyOptions || (fundingAgencyOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getAgencyOptions(setIsDropdownLoading)
      } else {
        if(fundingAgencyOptions?.length > 0){
          customCodedValues = fundingAgencyOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingRegion){
      if(!fundingRegionOptions || (fundingRegionOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getRegionOptions(setIsDropdownLoading);
      } else {
        if(fundingRegionOptions?.length > 0){
          customCodedValues = fundingRegionOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingUnit){
      if(!fundingUnitOptions || (fundingUnitOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getUnitOptions(setIsDropdownLoading);
      } else {
        if(fundingUnitOptions?.length > 0){
          customCodedValues = fundingUnitOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingSubUnit){
      if(!fundingSubUnitOptions || (fundingSubUnitOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getSubUnitOptions(setIsDropdownLoading);
      } else {
        if(fundingSubUnitOptions?.length > 0){
          customCodedValues = fundingSubUnitOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingTribe){
      if(!fundingTribeOptions || (fundingTribeOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getTribeOptions(setIsDropdownLoading);
      } else {
        if(fundingTribeOptions?.length > 0){
          customCodedValues = fundingTribeOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.fundingUnitType){
      if(!fundingUnitTypeOptions || (fundingUnitTypeOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getFundingUnitTypeOptions(setIsDropdownLoading);
      } else {
        if(fundingUnitTypeOptions?.length > 0){
          customCodedValues = fundingUnitTypeOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.county){
      if(!countyOptions || (countyOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getCountyOptions(setIsDropdownLoading)
      } else {
        if(countyOptions?.length > 0){
          customCodedValues = countyOptions;
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.status){
      if(statusOptions && statusOptions.length > 0){
        customCodedValues = statusOptions;
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.wbsID){
      if(wbsIDValues && wbsIDValues.length > 0){
        customCodedValues = wbsIDValues
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.type){
      if(actionCategoryAssociations){
        const postFireTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.types];
        const fuelsTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.types];
        let allTypes = [...new Set(postFireTypeValues.concat(fuelsTypeValues))]
        if(datasetSelection === FieldNames.datasets.fuels){
          allTypes = [...fuelsTypeValues]
        } else if(datasetSelection === FieldNames.datasets.postfire){
          allTypes = [...postFireTypeValues]
        }
        if(allTypes?.length){
          customCodedValues = allTypes.sort((a, b) => (a > b) ? 1 : -1)
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.category){
      if(actionCategoryAssociations){
        const postFireCategoryValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.categories];
        const fuelsCategoryValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.categories];
        let allCategories = [...new Set(postFireCategoryValues.concat(fuelsCategoryValues))]
        if(datasetSelection === FieldNames.datasets.fuels){
          allCategories = [...fuelsCategoryValues]
        } else if(datasetSelection === FieldNames.datasets.postfire){
          allCategories = [...postFireCategoryValues]
        }
        if(allCategories?.length){
          customCodedValues = allCategories.sort((a, b) => (a > b) ? 1 : -1)
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.class){
      let uniqueCategoryTypesByClass = [
        FieldNames.classTypes.activity, 
        FieldNames.classTypes.actualActivity, 
        FieldNames.classTypes.actualTreatment, 
        FieldNames.classTypes.treatment
      ];
      if(uniqueCategoryTypesByClass && uniqueCategoryTypesByClass.length){
        customCodedValues = uniqueCategoryTypesByClass.sort((a, b) => (a > b) ? 1 : -1)
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.state){
      const states = getStates();
      if(states && states.length > 0){
        let sortedAllItems = states.map(x => x.name).sort((a, b) => (a > b) ? 1 : -1);
        if(sortedAllItems && sortedAllItems.length){
          sortedAllItems.forEach(element => {
            customCodedValues.push(element);
          });
        }
      }
    } else if(name === FieldNames.filterNamesWithCustomSetting.name){
      if(!nameValueOptions || (nameValueOptions?.length === 0)){
        setIsDropdownLoading(true);
        customCodedValues = await getNameOptions(setIsDropdownLoading)
      } else {
        if(nameValueOptions?.length > 0){
          customCodedValues = nameValueOptions;
        }
      }
    }
    return customCodedValues;
  }

  const updateOptionsFromField = async (fieldInternal) => {
    let operatorInternal = getValidOperators(fieldInternal, fieldInternal.type)[0];
    let customCodedValues = [];
    if(fieldInternal.domain === "custom"){
      if(fieldInternal.name === "CongressionalDistrictNumber")
      {
        customCodedValues = await getCustomCodedValues(fieldInternal.name);
      } else if(fieldInternal.modelName === "HideNational" || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.status ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.wbsID || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.type ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.category || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.class
      ){
        operatorInternal = getStringExclusionOperator()[0];
        customCodedValues = await getCustomCodedValues(fieldInternal.modelName);
      } else if(fieldInternal.modelName === "HideContributedOnly")
      {
        operatorInternal = getEmptyOperator()[0];
        customCodedValues = await getCustomCodedValues(fieldInternal.modelName);
      } else if(fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingDepartment || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingSource ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingAgency || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingRegion ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingUnit || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingSubUnit ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingTribe || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingUnitType ||
        fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.county || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.name
      ){
        customCodedValues = await getCustomCodedValues(fieldInternal.modelName)
      } else if(fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.state){
        operatorInternal = getStringEquivalenceOperator()[0];
        customCodedValues = await getCustomCodedValues(fieldInternal.modelName)
      } 
    }
    const valueInternal = getDefaultFilterValue(fieldInternal, customCodedValues);

    updateExpressionInternal({
      fieldInternal,
      valueInternal,
      operatorInternal,
      valueType
    });

  };

  const getValueTypeChooser = (valueType, disableUnique) => {
    if (disableUnique) return (<span></span>);
    return (
      <ValueTypeChooser
        id={id}
        selectedValueType={valueType}
        onChange={handleValueTypeChanged}
      />
    );
  };

  const isOperatorHidden = (fieldInternal) => {
    //fieldInternal is something like this: {name: 'Category', type: 'esriFieldTypeString', alias: 'Category', domain: 'custom', editable: true, 
    //length: 255, modelName: "Category", nullable: true}
    if(!fieldInternal || !fieldInternal.name)
    {
      return false;
    }

    if(fieldInternal.name === 'HideNational' || fieldInternal.name === 'HideContributedOnly')
    {
      return true;
    }

    return false;
  }

  const isValueElementHidden = (fieldInternal) => {
    if(!fieldInternal || !fieldInternal.name)
    {
      return false;
    }

    if(fieldInternal.name === 'HideNational' || fieldInternal.name === 'HideContributedOnly')
    {
      return true;
    }

    return false;
  }

  const isValueTypeHidden = (fieldInternal) => {
    if(!fieldInternal || !fieldInternal.name)
    {
      return false;
    }

    if(fieldInternal.name === 'HideNational' || fieldInternal.name === 'HideContributedOnly')
    {
      return true;
    }

    return false;
  }

  if (!fields) return (<span></span>);

  const { valueType } = expressionDef;
  const operatorInternal = expressionDef.operator;
  const fieldInternal = expressionDef.field;
  const operators = (overrideStringOperators) ? getShortStringOperators() : fieldInternal ? getValidOperators(fieldInternal, fieldInternal.type) : getValidOperators('', '');
  //FieldChooser is for The first dropdown where you choose Class, Category, County, ...
  //OperatorChooser is for the second dropdown where you choose is, is not, is null, ...
  //FieldValueChooser is for the final dropdown/text field
    return (
      <div style={{ backgroundColor: `${ColorConstants.CustomFilterBackground}`, border: `1px solid ${ColorConstants.LessLightGrayAlien}`, borderRadius: 5, padding: 10 }}>
        <div name={`expression-${id}`} style={{ ...formControlContainerStyles }}>
          <FormControl style={{ flex: '1 0 150px', ...formControlStyles }}>
            <FieldChooser
              selectedField={(fields.length === 1) ? fields[0] : fieldInternal}
              fields={fields}
              onChange={handleFieldChanged}
            />
          </FormControl>
          <FormControl className = {isOperatorHidden(fieldInternal) ? 'hidden' : ''} style={formControlStyles}>
            <OperatorChooser
              selectedOperator={operatorInternal ? operatorInternal : ''}
              operators={operators}
              onChange={handleOperatorChanged}
            />
          </FormControl>
          <FormControl className = {isValueElementHidden(fieldInternal) ? 'hidden' : ''} style={{ flex: '1 0 150px', ...formControlStyles }}>
            <FieldValueChooser 
              expressionDef={expressionDef} 
              isDropdownLoading={isDropdownLoading} 
              handleValueChanged={handleValueChanged} 
              getCustomCodedValues={getCustomCodedValues}
              datasetSelection={datasetSelection}
            />
          </FormControl>
          <FormControl className = {isValueTypeHidden(fieldInternal) ? 'hidden' : ''} style={formControlStyles}>
            {getValueTypeChooser(valueType, disableUnique)}
          </FormControl>
          <FormControl style={deleteStyles}>
            <Tooltip title="Remove Expression" placement="left">
              <DeleteIcon
                className="filter-item-header-clear"
                onClick={removeExpressionInternal}
                style={{width: "30px", height: "40px", float: "right", paddingTop:"8px"}} />
              </Tooltip>
          </FormControl>
        </div>
      </div>
    );
}